import axios from 'axios'
import store from '@/store'

export default {
  getRoles () {
    if (store.state.roles.length) {
      return Promise.resolve(store.state.roles)
    }
    return new Promise((resolve, reject) => {
      axios.get('/api/roles').then(({ data }) => {
        store.dispatch('setRoles', data)
        resolve(data)
        return data
      }, error => {
        reject(error)
      })
    })
  }
}
